<template>
    <div class="input-wrapper">
        <v-autocomplete
              v-model="fieldValue"
              :items="list"
              :placeholder="placeholder"

              solo
              flat             
              validate-on-blur

              :style="{'height': fieldHeight}"
              :height="fieldHeight"
              >
              <template #append>
                <v-icon class="mt-1" color="primary">mdi-chevron-down</v-icon>
              </template>
            </v-autocomplete>
    </div>
</template>

<script>
export default {
    props: {
        value:Number,
        items: Array,
        fieldHeight: String,
        placeholder: String
    },
    computed: {
      fieldValue: {
        get() {
          return this.value
        },
        set(val) {
          console.log('vavtocomplete',val)
            this.$emit('input', val);         
        }
      },
      list() {
        return this.items;
      }
  
    },
}
</script>